import ProductColorModel from "./ProductColorModel";

export default class ProductColorsModel {
    productColors: Array<ProductColorModel> = [];
}
